import React, { useContext } from 'react';
import { BrowserRouter, Route, BrowserRouter as Router, Switch, Redirect  } from 'react-router-dom';
import { Container, Grid, Card, CardContent, Typography, AppBar, Toolbar, CssBaseline, Box, CardMedia } from '@mui/material';
import AppContext from './context/AppContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import AppState from './context/AppState';
import LoginPage from './pages/auth/Signin';
import ProductDashboard from './pages/components/ProductDashboard';


function PrivateRoute({ children, ...rest }) {

  const { setCategory, setAsset, setLocation, setGateway, setSocketData, setUserRole, setNotification } = useContext(AppContext)





  const { currentUser } = useAuth();
  const user = localStorage.getItem('user')
  currentUser?.getIdTokenResult().then((idTokenResult) => {
    let userRole = "napino"; // Default role

    if (!!idTokenResult.claims.superAdmin) {
      userRole = "superAdmin";
    } else if (!!idTokenResult.claims.admin) {
      userRole = "admin";
    }
    else if (!!idTokenResult.claims.demo) {
      userRole = "demo";
    }

    setUserRole(userRole);
    localStorage.setItem('userRole', userRole);
  });


  return (
    <Route
      {...rest}
      render={({ location }) =>
        user ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

function AuthRoute({ children, ...rest }) {
  const user = localStorage.getItem('user');

  return (
    <Route
      {...rest}
      render={({ location }) =>
        user ? (
          <Redirect
            to={{
              pathname: '/dashboard',
              state: { from: location },
            }}
          />
        ) : (
          children
        )
      }
    />
  );
}

function RedirectHandler() {
  const user = localStorage.getItem('user');
  return (
    <Redirect to={user ? "/dashboard" : "/"} />
  );
}

function App() {
  return (

    <AppState>
    <AuthProvider>
      <BrowserRouter>
        <Switch>
          <AuthRoute exact path="/">
            <LoginPage />
          </AuthRoute>
          <PrivateRoute exact path="/dashboard">
            <ProductDashboard/>
          </PrivateRoute>
       
          <RedirectHandler path="*">
          </RedirectHandler>

        </Switch>
      </BrowserRouter>
    </AuthProvider>
  </AppState>


    
  );
}

export default App;
